import _regeneratorRuntime from "@babel/runtime/helpers/esm/regeneratorRuntime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { codeAccessTokenExpired, codeRefreshTokenExpired, ERROR_CODE, ERROR_CODE_ZH, getTokenTenantId, refreshLoginByCode } from '../..';
import { storageTidKey } from '../../utils/storage';
import './index.less';
import { CommonBg } from '../common-bg';
import { useStatistics } from '../../utils/statistics';
var notChooseSchoolId = -999;
export var CHOOSE_ERROR_CODE;
(function (CHOOSE_ERROR_CODE) {
  CHOOSE_ERROR_CODE["UNAUTHORIZED"] = "401";
  CHOOSE_ERROR_CODE["REFRESH_FAIL"] = "40304";
  CHOOSE_ERROR_CODE["ERROR"] = "-1";
})(CHOOSE_ERROR_CODE || (CHOOSE_ERROR_CODE = {}));
export function ChooseSchool(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? '请选择学校' : _ref$title,
    tenants = _ref.tenants,
    curTenantId = _ref.curTenantId,
    showCreateBtn = _ref.showCreateBtn,
    _ref$onClickCreateBtn = _ref.onClickCreateBtn,
    onClickCreateBtn = _ref$onClickCreateBtn === void 0 ? function () {} : _ref$onClickCreateBtn,
    onSuccess = _ref.onSuccess,
    onError = _ref.onError,
    personal = _ref.personal,
    _ref$personalBackName = _ref.personalBackName,
    personalBackName = _ref$personalBackName === void 0 ? '飞象星球个人版' : _ref$personalBackName;
  useStatistics('ChooseSchool');
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isSaving = _useState2[0],
    setIsSaving = _useState2[1];
  var _useState3 = useState(notChooseSchoolId),
    _useState4 = _slicedToArray(_useState3, 2),
    selectedTid = _useState4[0],
    setSelectedTid = _useState4[1];
  var onSelectSchool = function onSelectSchool(tenantId) {
    setSelectedTid(tenantId);
  };
  var getTenantName = useCallback(function (item) {
    var name = item.name || item.institutionName;
    if (personal) {
      if (!name) {
        name = personalBackName;
      }
    }
    return name;
  }, [personal, personalBackName]);
  var onSaveSchool = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var res, curTid;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          if (!(isSaving || selectedTid === notChooseSchoolId)) {
            _context.next = 3;
            break;
          }
          return _context.abrupt("return");
        case 3:
          setIsSaving(true);
          if (!codeAccessTokenExpired()) {
            _context.next = 8;
            break;
          }
          if (!codeRefreshTokenExpired()) {
            _context.next = 8;
            break;
          }
          // accessToken 过期并且 refreshToken也过期，需要登录
          onError && onError({
            code: CHOOSE_ERROR_CODE.UNAUTHORIZED,
            message: '未登录或登录已过期'
          });
          return _context.abrupt("return");
        case 8:
          _context.next = 10;
          return refreshLoginByCode({
            tenantId: selectedTid
          });
        case 10:
          res = _context.sent;
          setIsSaving(false);
          if (!(res !== true)) {
            _context.next = 18;
            break;
          }
          if (!(res === ERROR_CODE.REFRESH_FAIL)) {
            _context.next = 16;
            break;
          }
          onError && onError({
            code: CHOOSE_ERROR_CODE.REFRESH_FAIL,
            message: ERROR_CODE_ZH[res]
          });
          return _context.abrupt("return");
        case 16:
          onError && onError({
            code: CHOOSE_ERROR_CODE.ERROR,
            message: '保存失败，请稍候再试'
          });
          return _context.abrupt("return");
        case 18:
          curTid = getTokenTenantId();
          localStorage.setItem(storageTidKey, curTid ? String(curTid) : '');
          onSuccess && onSuccess(selectedTid);
          _context.next = 28;
          break;
        case 23:
          _context.prev = 23;
          _context.t0 = _context["catch"](0);
          setIsSaving(false);
          console.warn(_context.t0);
          onError && onError({
            code: CHOOSE_ERROR_CODE.ERROR,
            message: '保存失败，请稍候再试'
          });
        case 28:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 23]]);
  })), [isSaving, onError, onSuccess, selectedTid]);
  var showingTitle = useMemo(function () {
    return /*#__PURE__*/React.createElement("div", {
      className: "login-choose-school-title-wrap"
    }, /*#__PURE__*/React.createElement("div", {
      className: "login-choose-school-title"
    }, title), showCreateBtn && /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "login-choose-school-title-button",
      onClick: onClickCreateBtn
    }, "\u521B\u5EFA\u4E2A\u4EBA\u7248"));
  }, [onClickCreateBtn, showCreateBtn, title]);
  var content = useMemo(function () {
    return /*#__PURE__*/React.createElement("div", {
      className: "login-choose-school-roles"
    }, tenants.map(function (item, index) {
      return /*#__PURE__*/React.createElement("div", {
        className: "login-choose-school-role-item ".concat(item.tenantId === selectedTid || item.institutionId === selectedTid ? 'login-choose-school-role-item-active' : ''),
        key: item.tenantId || item.institutionId,
        title: getTenantName(item),
        onClick: function onClick() {
          return onSelectSchool(item.tenantId || item.institutionId);
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "login-choose-school-role-item-name"
      }, getTenantName(item)));
    }));
  }, [getTenantName, selectedTid, tenants]);
  var footer = useMemo(function () {
    return /*#__PURE__*/React.createElement("span", {
      className: "btn-primary ".concat(selectedTid === notChooseSchoolId ? 'disabled' : ''),
      onClick: function onClick() {
        return onSaveSchool();
      }
    }, "\u786E\u5B9A");
  }, [onSaveSchool, selectedTid]);
  useEffect(function () {
    if (curTenantId) {
      setSelectedTid(curTenantId);
    }
  }, [curTenantId]);
  return /*#__PURE__*/React.createElement(CommonBg, {
    className: className,
    style: style,
    onClick: onClick,
    title: showingTitle,
    content: content,
    footer: footer
  });
}